import * as React from 'react';
import { connect } from 'react-redux';
import {
    OverlayContainer,
    Button,
    CloseButton,
    Panel,
    PanelHeader,
    PanelBody
} from 'components';
import {
    getOperationSafe,
    getFavListData,
    getOmjsProjectInstance
} from 'selectors';
import { IState } from 'services/root-reducer';
import {
    FavoritesExportLayerChooserOperation,
    actions as overlayWindowsActions
} from 'services/overlay-windows/overlay-windows-service';
import { WithTranslation, withTranslation } from 'react-i18next';


import './style.scss';
import { FavoritesExportLayerList } from './layers-list';

export interface IFavoritesLayerChooserOverlayProps extends WithTranslation {
    favoritesLayerExportOperation: FavoritesExportLayerChooserOperation;
}
export interface IFavoritesLayerChooserOverlayState {}

const mapStateToProps = (state: IState) => ({
    favoritesLayerExportOperation: getOperationSafe(state, 'EXPORT_OBJECTS_LAYER_CHOOSER_OVERLAY'),
    project: getOmjsProjectInstance(state)
});

/* eslint-disable @typescript-eslint/indent */
class FavoritesLayerChooserOverlayComponent extends React.Component<
    IFavoritesLayerChooserOverlayProps,
    IFavoritesLayerChooserOverlayState
> {
/* eslint-enable @typescript-eslint/indent */

    constructor(props: IFavoritesLayerChooserOverlayProps) {
        super(props);

        this.onCloseButtonClick = this.onCloseButtonClick.bind(this);
    }

    onCloseButtonClick() {
        overlayWindowsActions.hideExportLayerChooserOverlay();
    }

    render() {
        let { favoritesLayerExportOperation } = this.props;
        if (
            !favoritesLayerExportOperation.data?.visible
            || !favoritesLayerExportOperation.data?.objects
        ) {
            return null;
        }

        return (
            <OverlayContainer
                className='favorites-layer-chooser'
                backgroundOpacity={6}
            >
                <Panel className='favorites-layer-chooser-panel'>
                    <PanelHeader className='favorites-layer-chooser-panel-header'>
                        <div className="header-text">
                            {this.props.t('Выберите слой для выгрузки')}
                        </div>
                        <CloseButton onClick={this.onCloseButtonClick} />
                    </PanelHeader>
                    <PanelBody className='favorites-layer-chooser-panel-body'>
                        <FavoritesExportLayerList />
                    </PanelBody>
                </Panel>
            </OverlayContainer>
        );
    }
}

export const FavoritesLayerChooserOverlay = connect(mapStateToProps)(
    withTranslation()(FavoritesLayerChooserOverlayComponent)
);
